import { useBoundStore } from "e3-common/store/useBoundStore";

export default function useMessageBox() {
  const { setMessageBoxAttributes, responseHandler, setResponseHandler } = useBoundStore((state) => state.messageBox);

  const onInteractionEnd = (value) => {
    setMessageBoxAttributes({
      revealed: false,
      title: "",
      description: "",
      type: "",
      time: 0,
    });
    responseHandler?.(value);
  };

  const setAttributes = (type, title, description, time) => {
    setMessageBoxAttributes({
      revealed: true,
      title,
      description,
      type,
      time,
    });
  };

  const confirm = (title, description = "", time = 0) => {
    setAttributes("confirm", title, description, time);

    return new Promise((res) => {
      setResponseHandler(res);
    });
  };

  const alert = (title, description = "", time = 0) => {
    setAttributes("alert", title, description, time);

    return new Promise((res) => {
      setResponseHandler(res);
    });
  };

  const error = (title, description = "", time = 0) => {
    setAttributes("error", title, description, time);

    return new Promise((res) => {
      setResponseHandler(res);
    });
  };

  const prompt = (title, description = "", time = 0) => {
    setAttributes("prompt", title, description, time);

    return new Promise((res) => {
      setResponseHandler(res);
    });
  };

  return {
    confirm,
    alert,
    error,
    prompt,
    onInteractionEnd,
  };
}
